export const INDEX_PAGE_EVENT_NAME = 'index_page_events'
export const FSF_EVENT_NAME = 'fsf_events'
export const FSF_CALENDAR = 'fsf_calendar'
export const CLP_EVENT_NAME = 'clp_event'
export const SUBSCRIPTION_POPUP_GENERIC_EVENT_NAME = 'subscription_popup'
export const SUBSCRIPTION_POPUP_EVENT_NAME = 'subscription_popup'

export const INDEX_PAGE_TYPE = 'index'
export const MMB_LOGIN_PAGE_TYPE = 'mmb_login'
export const CKIN_LOGIN_PAGE_TYPE = 'ckin_login'
export const SDP_EVENT_NAME = 'single_destination_page_events'
export const SDP_PAGE_TYPE = 'single_destination_page'
